import { shallowRef, computed } from 'vue';

// Global app-state
const config = shallowRef(null);

const useEnvironment = (envConfig) => {
    if (envConfig) {
        config.value = envConfig;
    }
    return { config };
};

const isLocalEnv = computed(
    () => window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '::1',
);

export { useEnvironment, isLocalEnv };
